module.exports = __webpack_public_path__ + "img/sweden-ischemic-heart-disease-male.8b812932.png";